module.exports = __webpack_public_path__ + "img/29fad3a.png";